import { ConfirmationService } from 'primeng/components/common/api';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { LoyaltyReportService } from 'app/services/loyalty/loyalty-report.service';
import { SelectItem } from 'primeng/primeng';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-loyalty-report-list',
  templateUrl: './loyalty-report-list.component.html',
  styleUrls: ['./loyalty-report-list.component.css']
})
export class LoyaltyReportListComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  selectFilter = KontableComponent.SelectFilter;
  dateFilter = KontableComponent.DateFilter;
  reportStates: SelectItem[] = [
    {label: this.translateService.instant('common.all'), value: null},
    {label: this.translateService.instant('report.generated'), value: "0"},
    {label: this.translateService.instant('report.onError'), value: "E"},
    {label: this.translateService.instant('report.downloadReady'), value: "P"},
    {label: this.translateService.instant('report.onExecution'), value: "A"}
  ];
  showModal = false;
  @ViewChild('table') table: KontableComponent;

  constructor(
    public reportService: LoyaltyReportService,
    private translateService: TranslateService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
  }

  downloadReport(reportId: number, reportCode: string) {
    const fileName = `${reportId}_${reportCode}.xlsx`;
    this.reportService.downloadReport(fileName).subscribe(res => FileSaver.saveAs(res, fileName));
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  onSaveReport() {
    this.table.refresh();
    this.closeModal();
  }

  showProcessingDetail(detailMsg: string) {
    this.confirmationService.confirm({
      header: this.translateService.instant('report.processingDetail'),
      message: detailMsg,
      acceptLabel: 'Ok',
      rejectVisible: false
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-report-list/loyalty-report-list.component.ts